import { Injectable } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { AppSpinnerComponent } from '../components/app-spinner/app-spinner.component'

@Injectable({ providedIn: 'root' })
export class AppSpinnerService {
   public spinner?: MatDialogRef<AppSpinnerComponent>

   private isShown?: boolean
   private isStartupLoading = false

   constructor(public dialog: MatDialog) {}

   startupShow() {
      this.isStartupLoading = true
      this.spinnerShow()
   }

   startupHide() {
      if (!this.isStartupLoading) return

      this.isStartupLoading = false
      this.spinnerHide()
   }

   spinnerShow() {
      this.isShown = this.dialog.getDialogById('spinner-dialog') ? true : false

      if (!this.isShown) {
         this.spinner = this.dialog.open(AppSpinnerComponent, {
            panelClass: 'app-spinner',
            disableClose: true,
            backdropClass: 'app-spinner-overlay',
            id: 'spinner-dialog'
         })
         this.isShown = true
      }
   }

   spinnerHide() {
      if (this.isStartupLoading) return

      if (this.isShown) {
         this.dialog.getDialogById('spinner-dialog')?.close()
         this.isShown = false
      }
   }
}
